import React from 'react'
import Hero from './Hero/Hero'
import ProjectGrid from './ProjectGrid/ProjectGrid'
import HomeAboutme from './Aboutme/HomeAboutme'

function Home() {

    return (
        <div>

            {/* <OGHeader></OGHeader> */}
            <Hero></Hero>
            
            {/* <Stack></Stack> */}
            <ProjectGrid></ProjectGrid>

            <div className="top-3xl"></div>
            <div className="top-3xl"></div>
            <div className="top-3xl"></div>
            <div className="top-3xl"></div>

            <HomeAboutme></HomeAboutme>


            <div className='dummyheight'>

            </div>

        </div>

    )
}

export default Home